import { render, staticRenderFns } from "./Handreiking.vue?vue&type=template&id=9ca09592&scoped=true&"
import script from "./Handreiking.vue?vue&type=script&lang=js&"
export * from "./Handreiking.vue?vue&type=script&lang=js&"
import style0 from "./Handreiking.vue?vue&type=style&index=0&id=9ca09592&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca09592",
  null
  
)

export default component.exports